import { Crumbs } from '../bakery/Crumbs';
import { FamilyMember } from '../FamilyMember/FamilyMember';
import { RxdbCollectionNameV2 } from '../RxdbCollectionNameV2';
import { Synchronizable } from '../Synchronizable/Synchronizable';

// Replication states are sometimes typed, but we don't care about that type,
// so we'll allow it but forget it here.
// This saves us from having to cast every single FamilyMember.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FamilyMembers = Partial<Record<RxdbCollectionNameV2, FamilyMember<any>>>;

export interface Family extends Synchronizable {
  readonly members: FamilyMembers;
}

export function crumbleFamily(family: Family): Crumbs {
  const { members, name, syncState } = family;
  return {
    members: Object.keys(members).length,
    name,
    syncState,
  };
}
